import React from 'react'
import AuthLayout from './AuthLayout'

export * from './AuthLayout'
export default React.memo(AuthLayout)
